import DOMPurify from 'dompurify';

export default function createElement(tag, attributes=null, children=null) {
  const element = document.createElement(tag);

  if (attributes && typeof attributes === 'object') {
    for (const attribute in attributes) {
      const value = attributes[attribute];
      if (isEventName(element, attribute)) {
        element[attribute] = value;
      } else {
        element.setAttribute(attribute, value);
      }
    }
  }

  if (typeof children === 'string') {
    children = [children];
  }
  if (Array.isArray(children)) {
    children.forEach((child) => {
      if (child instanceof HTMLElement) {
        element.append(child);
      } else if (typeof child === 'string') {
        const content = DOMPurify.sanitize(child);
        element.innerHTML += content;
      }
    });
  }

  return element;
}

function isEventName(element, attribute) {
  if (attribute.startsWith('on')) {
    const eventName = attribute.replace(/^on/i, '');
    if (eventName in element) {
      return true;
    }
  }
  return false;
}
